export default __webpack_public_path__ + "static/media/PREMA.18ba8942.png";